export var METHODS = {
    policy: 'getCurrentConsentPolicy',
    header: '_getConsentPolicyHeader',
    isMethod: true,
};
export var PROPS_ACCESS = {
    policy: 'consentPolicy',
    header: 'consentPolicyHeader',
    isMethod: false,
};
export var ALLOW_ALL_POLICY = {
    essential: true,
    dataToThirdParty: true,
    advertising: true,
    functional: true,
    analytics: true,
};
//# sourceMappingURL=consts.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/@wix/consent-policy-client-accessor/dist/es/src/consts.js
// module id = 124
// module chunks = 0 1